"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var types = __importStar(require("./actionTypes"));
var initialState = {
    businessId: undefined,
    viaName: '',
    pipelineVersion: 1,
    activePartners: [],
};
function reduce(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types.SET_BUSINESS_ID:
            return __assign(__assign({}, state), { businessId: action.data.businessId });
        case types.SET_VIA_NAME:
            return __assign(__assign({}, state), { viaName: action.data.viaName });
        case types.SET_PIPELINE_VERSION:
            return __assign(__assign({}, state), { pipelineVersion: action.data.pipelineVersion });
        case types.SET_ACTIVE_PARTNERS:
            return __assign(__assign({}, state), { activePartners: action.data.activePartners });
        default:
            return state;
    }
}
exports["default"] = reduce;
